import { Controller } from "stimulus"

export default class extends Controller {

  initialize() {
    // validations
    this.addTeamMemberForm = this.addTeamMemberForm();
    this.addModalEventListener()
  }

  addModalEventListener() {
    let self = this;
    let addTeamMemberModal = document.getElementById('addTeamMemberModal')
    addTeamMemberModal.addEventListener('shown.bs.modal', function (event) {
      // Focus on the first visible input field in the modal
      let inputs = addTeamMemberModal.querySelectorAll('input');
      for(let i = 0; i < inputs.length; i++) {
        if(inputs[i].type !== 'hidden' && window.getComputedStyle(inputs[i]).display !== 'none') {
          inputs[i].focus();
          break;
        }
      }
    })

  }

  submitTeamMemberForm() {
    document.getElementById("addTeamMemberSubmit").disabled = true;
    this.addTeamMemberForm.validate().then(function (status) { 
      if (status == 'Valid') {
        document.getElementById("addTeamMemberForm").submit();
      } else {
        document.getElementById("addTeamMemberSubmit").disabled = false;
      }
    });
  }

  addTeamMemberForm(){
    let self = this;
    return FormValidation.formValidation(
      document.getElementById('addTeamMemberForm'),
      {
        fields: {
          name: {
            selector: '[name="team_member_form[name]"]',
            validators: {
              notEmpty: {
                trim: true,
                message: 'Full name is required'
              },
              stringLength: {
                max: 255,
                message: 'Full name must be less than 255 characters'
              }
            }
          },
          email: {
            selector: '[name="team_member_form[email]"]',
            validators: {
              emailAddress: {
                message: 'Please enter valid email'
              },
              stringLength: {
                max: 255,
                message: 'Email must be less than 255 characters'
              },
              notEmpty: {
                trim: true,
                message: 'Email is required'
              },
            }
          },
        },
        plugins: {
          bootstrap5: new Bootstrap5({
            rowSelector: '.g-5'
          }),
          alias: new FormValidation.plugins.Alias({
            checkValidNumber: 'callback',
            emailOrPhonePresent: 'callback',
            facilitatorEmailPresent: 'callback'
          }),
          submitButton: new FormValidation.plugins.SubmitButton()
      },
    })
  }

}